import { __decorate } from "tslib";
import { LitElement, html } from 'lit';
import { customElement, property, query, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { styleMap } from 'lit/directives/style-map.js';
import { getFormattedTime } from '@amityeko/pbc-core/dist/utilities/datetime';
import speakerOffIcon from '../../assets/icons/speaker-off';
import speakerOnIcon from '../../assets/icons/speaker-on';
import '../button';
import '../icon';
import '../typography/tg-caption';
import styles from './styles';
/**
 * @dependency amityeko-button
 * @dependency amityeko-icon
 * @dependency amityeko-tg-caption
 *
 */
let RnRVideo = class RnRVideo extends LitElement {
    constructor() {
        super(...arguments);
        this.isShowPlayPauseBtn = false;
        this.isShowControls = false;
        this.isPlaying = false;
        this.isMuted = false;
    }
    _play() {
        if (this.video.paused) {
            this.video.play();
            this.isPlaying = true;
        }
        else {
            this.video.pause();
            this.isPlaying = false;
        }
    }
    _onTimeUpdate() {
        if (this.video.ended) {
            this.isPlaying = false;
        }
        if (!this.isShowControls)
            return;
        const remainingTime = this.video.duration - this.video.currentTime;
        if (isNaN(remainingTime)) {
            this.currentTime = undefined;
            this.remainingTime = undefined;
            this.inner.style.width = `0%`;
        }
        else {
            this.currentTime = getFormattedTime(this.video.currentTime);
            this.remainingTime = getFormattedTime(remainingTime);
            let width = (this.video.currentTime / this.video.duration) * 100;
            this.inner.style.width = `${width}%`;
        }
    }
    _onMuted() {
        this.video.muted = !this.video.muted;
        this.isMuted = !this.isMuted;
    }
    render() {
        if (!this.videoURL)
            return;
        return html `<div class="container">

      <video
        class="video"
        id="video"
        src=${this.videoURL}
        @timeupdate=${this._onTimeUpdate}
      >
        Your browser does not support the video player.
      </video>
      ${this.animation ? html `<img class="video__animation" src=${this.animation} />` : null}
      ${this.isShowPlayPauseBtn
            ? html `<div @click=${this._play} class="control">
              <div
                class=${classMap({
                button: true,
                'button--pause': this.isPlaying,
            })}
              ></div>
            </div>`
            : null}

      ${!this.isTitleEmbedded && this.videoTitle
            ? html `<div class="video__title">
              <amityeko-tg-title
                style=${styleMap({
                '--private-title-color': this.videoTitleColor,
            })}
                >${this.videoTitle}</amityeko-tg-title
              >
            </div>`
            : null}

      ${this.isShowControls
            ? html `
           <div class="controls">
            <div class="speaker">
              ${this.isMuted
                ? html `<amityeko-button
                      @click=${this._onMuted}
                      variant="primary"
                      .customColor=${'rgba(0, 0, 0, 0.5)'}
                      circle
                    >
                      <amityeko-icon .iconSize=${'18px'}>${speakerOffIcon}</amityeko-icon>
                    </amityeko-button>`
                : html `<amityeko-button
                      @click=${this._onMuted}
                      variant="primary"
                      .customColor=${'rgba(0, 0, 0, 0.5)'}
                      circle
                    >
                      <amityeko-icon .iconSize=${'18px'}>${speakerOnIcon}</amityeko-icon>
                    </amityeko-button>`}
            </div>
            <div class="controls__bottom">
                <div class="timeline">
                <div class="bar">
                    <div id="inner" class="inner"></div>
                    <div class="progress__circle"></div>
                </div>
                </div>
                <div class="time">
                  ${this.currentTime
                ? html `<amityeko-tg-caption>${this.currentTime}</amityeko-tg-caption>`
                : null}   
                  ${this.remainingTime
                ? html `<amityeko-tg-caption>${'-' + this.remainingTime}</amityeko-tg-caption>`
                : null}
                </div>
                <div class="play" @click=${this._play}>
                    <div
                        class=${classMap({
                button: true,
                'button--pause': this.isPlaying,
            })}> 
                    </div>
                </div>
            </div>
      </div>
      </div>
        `
            : null}
      </div>
    </div>`;
    }
};
RnRVideo.styles = styles;
__decorate([
    query('#video')
], RnRVideo.prototype, "video", void 0);
__decorate([
    query('#inner')
], RnRVideo.prototype, "inner", void 0);
__decorate([
    property()
], RnRVideo.prototype, "videoURL", void 0);
__decorate([
    property()
], RnRVideo.prototype, "videoTitle", void 0);
__decorate([
    property({ type: Boolean })
], RnRVideo.prototype, "isTitleEmbedded", void 0);
__decorate([
    property()
], RnRVideo.prototype, "videoTitleColor", void 0);
__decorate([
    property()
], RnRVideo.prototype, "animation", void 0);
__decorate([
    property({ type: Boolean })
], RnRVideo.prototype, "isShowPlayPauseBtn", void 0);
__decorate([
    property({ type: Boolean })
], RnRVideo.prototype, "isShowControls", void 0);
__decorate([
    state()
], RnRVideo.prototype, "currentTime", void 0);
__decorate([
    state()
], RnRVideo.prototype, "remainingTime", void 0);
__decorate([
    state()
], RnRVideo.prototype, "isPlaying", void 0);
__decorate([
    state()
], RnRVideo.prototype, "isMuted", void 0);
RnRVideo = __decorate([
    customElement('rnr-video')
], RnRVideo);
export default RnRVideo;
//# sourceMappingURL=index.js.map